import React from "react";

export function Eyebrow({ children, className = "" }) {
  return <p className={`eyebrow ${className}`}>{children}</p>;
}

export function SectionHeading({ eyebrow, title, subtitle, center = true, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto max-w-2xl" : ""} ${className}`}>
      {eyebrow && <Eyebrow className="mb-3">{eyebrow}</Eyebrow>}
      <h2 className="font-display text-4xl sm:text-5xl text-[var(--charcoal)] leading-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-[var(--charcoal-soft)] text-base leading-relaxed">{subtitle}</p>
      )}
    </div>
  );
}

export function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="bg-[var(--cream-2)] border-b border-[var(--line)]">
      <div className="max-w-[1100px] mx-auto px-5 lg:px-10 py-20 text-center animate-fade-up">
        {eyebrow && <Eyebrow className="mb-4">{eyebrow}</Eyebrow>}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--charcoal)] leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-[var(--charcoal-soft)] max-w-2xl mx-auto text-base leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
